import { ButtonComponent } from '@shared/ui/components/button/button.component';
import { Component, output} from '@angular/core';

@Component({
  selector: 'app-sign-in-method-select',
  standalone: true,
  imports: [ButtonComponent],
  template: `
    <p class="welcome-text">Welcome, please select your login method</p>
    <div class="method-selection">
      <app-button type="button" variant="secondary" (click)="selectMethod.emit('sso')">
        SSO
      </app-button>

      <app-button type="button" variant="secondary" (click)="selectMethod.emit('password')">
        Email & Password
      </app-button>
    </div>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
      }
      .welcome-text {
        font-size: var(--aida-ref-font-size-400);
        color: var(--aida-colour-text-tertiary);
        font-family: var(--font-family-base), sans-serif;
        margin-bottom: var(--aida-ref-spacing-300);
      }

      .method-selection {
        display: flex;
        flex-direction: column;
        gap: var(--aida-ref-spacing-150);
        justify-items: center;
      }
    `,
  ],
})
export class SignInMethodSelectComponent {
  selectMethod = output<'sso' | 'password'>();
}
